<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-center">
            <v-avatar color="blue">
              <span class="white--text headline">{{
                user ? user.Initials : ""
              }}</span>
            </v-avatar>
            <h2 class="font-weight-light">
              Welcome, {{ user ? user.First : "" }} {{ user ? user.Last : "" }}
            </h2>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="mx-auto" max-width="400">
            <v-card-title>
              <v-icon large left>
                mdi-credit-card
              </v-icon>
              <span class="title font-weight-light">Payment information</span>
            </v-card-title>

            <v-card-text class="text--primary">
              <div>Add, delete or update your card information</div>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" text to="/payments-and-subscriptions">
                Manage payments
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="mx-auto" max-width="400">
            <v-card-title>
              <v-icon large left>
                mdi-map-marker
              </v-icon>
              <span class="title font-weight-light">Shipping information</span>
            </v-card-title>

            <v-card-text class="text--primary">
              <div>Add, delete or update your address</div>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" text to="/addresses">
                Edit address
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="mx-auto" max-width="400">
            <v-card-title>
              <v-icon large left>
                mdi-account
              </v-icon>
              <span class="title font-weight-light">Account information</span>
            </v-card-title>

            <v-card-text class="text--primary">
              <div>manage account information</div>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" text to="/profile">
                Account information
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="mx-auto" max-width="400">
            <v-card-title>
              <v-icon large left>
                mdi-playlist-check
              </v-icon>
              <span class="title font-weight-light">Subscriptions</span>
            </v-card-title>

            <v-card-text class="text--primary">
              <div>manage Subscriptions</div>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" text to="/payments-and-subscriptions">
                Subscriptions
              </v-btn>
            </v-card-actions>
            <v-overlay :absolute="absolute" value="true">
              <h2>Coming soon</h2>
            </v-overlay>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Account",
  data() {
    return {
      drawer: null,
      absolute: true,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
};
</script>
